import {_request, _requestForm} from "./api";

export const add = (date) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _requestForm({
            target: 'supervisor', method: 'POST', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const edit = (date,document_guid) => {
    let params = date
    return new Promise((resolve, reject) => {
        return _requestForm({
            target: `supervisor/${document_guid}`, method: 'PUT', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const remove = (document_guid) => {
    return new Promise((resolve, reject) => {
        return _request({
            target: `supervisor/${document_guid}`, method: 'DELETE'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const item = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'supervisor/item', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const list = (date) => {
    let params = date;
    return new Promise((resolve, reject) => {
        return _request({
            target: 'supervisor', method: 'GET', params: params
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    })
};

export const listType = () => {
    return new Promise((resolve, reject) => {
        return _request({
            target: 'supervisor/type', method: 'GET'
        })
            .then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error);
            });
    });
};
